<script>
  import { mapGetters } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  export default {
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'ImageGalleries',
        'DesignSettings',
        'MainMenu',
        'MainMenuList',
        'MoreMenuIconURL'
      ]),
      getItemStyle() {
        if (Helper.IsValid(this.MainMenu.MenuItemFontColor)) {
          let hashCode = Helper.HashCodeFromInt(this.MainMenu.MenuItemFontColor)
          return {
            'color': hashCode,
            'font-family': this.MainMenu.MenuItemFontName
          }
        }
      }
    },
    mounted(){
    console.log("MEnu ITem LIsrt =>", this.MainMenuList)
  },
    methods: {
      getItemcontainerStyle(backgroundColor) {
        if (Helper.IsValid(this.MainMenu.MenuItemFontColor)) {
          let hashCodefc = Helper.HashCodeFromInt(this.MainMenu.MenuItemFontColor)
          let hashCodebc = Helper.HashCodeFromInt(backgroundColor)
          let colorrgb = Helper.hexToRgb(hashCodebc)
          return {
            'color': hashCodefc,
            'background': 'rgba(' + colorrgb + ',' + this.MainMenu.MenuItemContainerOpacity + ')'
          }
        }
      },
      IsNullOrEmpty(value) {
        return Helper.IsNullOrEmpty(value)
      }
    }
  }
</script>
<template>
  <div>
    <div class="main-menu-gird" v-if="MainMenuList.length > 6">
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
            <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
            <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[2].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[2].url}/${MainMenuList[2].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[2].MenuIcon)}" :src="MainMenuList[2].MenuIcon">
            <div v-if="MainMenuList[2].UnreadChatMessageCount && MainMenuList[2].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[2].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[2].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[3].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[3].url}/${MainMenuList[3].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[3].MenuIcon)}" :src="MainMenuList[3].MenuIcon">
            <div v-if="MainMenuList[3].UnreadChatMessageCount && MainMenuList[3].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[3].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[3].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[4].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[4].url}/${MainMenuList[4].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[4].MenuIcon)}" :src="MainMenuList[4].MenuIcon">
            <div v-if="MainMenuList[4].UnreadChatMessageCount && MainMenuList[4].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[4].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[4].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenu.MenuItemOverflowBackgroundColor)">
          <f7-link popup-open="#more-popup">
            <img :src="MoreMenuIconURL">            
            <span :style="getItemStyle">{{MainMenu.MenuItemOverflowLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length == 6">
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
            <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
            <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[2].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[2].url}/${MainMenuList[2].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[2].MenuIcon)}" :src="MainMenuList[2].MenuIcon">
            <div v-if="MainMenuList[2].UnreadChatMessageCount && MainMenuList[2].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[2].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[2].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[3].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[3].url}/${MainMenuList[3].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[3].MenuIcon)}" :src="MainMenuList[3].MenuIcon">
            <div v-if="MainMenuList[3].UnreadChatMessageCount && MainMenuList[3].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[3].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[3].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[4].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[4].url}/${MainMenuList[4].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[4].MenuIcon)}" :src="MainMenuList[4].MenuIcon">
            <div v-if="MainMenuList[4].UnreadChatMessageCount && MainMenuList[4].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[4].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[4].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[5].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[5].url}/${MainMenuList[5].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[5].MenuIcon)}" :src="MainMenuList[5].MenuIcon">
            <div v-if="MainMenuList[5].UnreadChatMessageCount && MainMenuList[5].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[5].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[5].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length === 5">
      <div class="row">
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
             <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
             <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[2].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[2].url}/${MainMenuList[2].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[2].MenuIcon)}" :src="MainMenuList[2].MenuIcon">
             <div v-if="MainMenuList[2].UnreadChatMessageCount && MainMenuList[2].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[2].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[2].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[3].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[3].url}/${MainMenuList[3].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[3].MenuIcon)}" :src="MainMenuList[3].MenuIcon">
             <div v-if="MainMenuList[3].UnreadChatMessageCount && MainMenuList[3].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[3].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[3].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[4].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[4].url}/${MainMenuList[4].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[4].MenuIcon)}" :src="MainMenuList[4].MenuIcon">
             <div v-if="MainMenuList[4].UnreadChatMessageCount && MainMenuList[4].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[4].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[4].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length === 4">
      <div class="row">
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
             <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
             <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
      <div class="row">
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[2].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[2].url}/${MainMenuList[2].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[2].MenuIcon)}" :src="MainMenuList[2].MenuIcon">
             <div v-if="MainMenuList[2].UnreadChatMessageCount && MainMenuList[2].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[2].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[2].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[3].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[3].url}/${MainMenuList[3].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[3].MenuIcon)}" :src="MainMenuList[3].MenuIcon">
             <div v-if="MainMenuList[3].UnreadChatMessageCount && MainMenuList[3].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[3].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[3].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length === 3">
      <div class="row">
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
             <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
             <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-33" :style="getItemcontainerStyle(MainMenuList[2].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[2].url}/${MainMenuList[2].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[2].MenuIcon)}" :src="MainMenuList[2].MenuIcon">
             <div v-if="MainMenuList[2].UnreadChatMessageCount && MainMenuList[2].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[2].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[2].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length === 2">
      <div class="row">
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
             <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
        <div class="col-50" :style="getItemcontainerStyle(MainMenuList[1].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[1].url}/${MainMenuList[1].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[1].MenuIcon)}" :src="MainMenuList[1].MenuIcon">
             <div v-if="MainMenuList[1].UnreadChatMessageCount && MainMenuList[1].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[1].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[1].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>

    <div class="main-menu-gird" v-if="MainMenuList.length === 1">
      <div class="row">
        <div class="col-100" :style="getItemcontainerStyle(MainMenuList[0].MenuIconColor)">
          <f7-link :href="`/${MainMenuList[0].url}/${MainMenuList[0].Id}`">
            <img :class="{'black-image-space' : IsNullOrEmpty(MainMenuList[0].MenuIcon)}" :src="MainMenuList[0].MenuIcon">
             <div v-if="MainMenuList[0].UnreadChatMessageCount && MainMenuList[0].UnreadChatMessageCount > 0" 
              class="badge">{{MainMenuList[0].UnreadChatMessageCount}}</div>
            <span :style="getItemStyle">{{MainMenuList[0].MenuLabel}}</span>
          </f7-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  /* .badge{
    min-width: 16px;
    position: absolute;
    top: -3px;
    line-height: 16px;
    font-size: 10px;
    padding: 0 6px;
    height: 16px;
    font-family: -apple-system, SF UI Text, Helvetica Neue, Helvetica, Arial, sans-serif;
    margin-left: -9px;
  }
  .black-image-space + .badge {
    top: 10px;
    left: 70%;
  } */
</style>


// WEBPACK FOOTER //
// src/components/shared/menu-layout/GridMenu.vue